import { Theme, css } from '@emotion/react';

export const base = (theme: Theme) => css``;

export const dividerThickMobile = ({ breakpoints }: Theme) => css`
  ${breakpoints.up('sm')} {
    display: none;
  }
`;

export const dividerThinDesktop = ({ breakpoints }: Theme) => css`
  display: none;
  ${breakpoints.up('sm')} {
    display: inherit;
  }
`;

export const formSection = (
  { breakpoints, colors, spacing }: Theme,
  { background, nested, box }: { background: boolean; nested: boolean; box: boolean }
) => [
  nested
    ? css`
        background: transparent;
        padding: 0;
      `
    : css`
        padding: ${spacing(4)}px 20px ${spacing(5)}px;
        background: ${background ? colors.bgLighter : colors.bgDefault};
        ${breakpoints.up('sm')} {
          padding: ${spacing(4)}px ${background || box ? spacing(3.5) : 0}px ${spacing(5)}px;
        }
      `,
  box &&
    css`
      ${breakpoints.up('sm')} {
        border: 1px solid ${colors.borderDefault};
      }
    `,
];
